
import { Component, Prop, Vue} from "vue-property-decorator";

import GET_FAVORITES from "@/apollo/dashboard/getFavorites.gql";

import DashboardCardScaffold from "@/components/dashboard/cards/CardScaffold.vue";
import CardItemScaffold from "@/components/dashboard/cards/CardItemScaffold.vue";
import InvitationModalWithButton from "@/components/companyContractors/InvitationModalWithButton.vue";
import HeartIcon from "@/components/icons/HeartIcon.vue";
import ItemChipsWithMore from "@/components/common/ItemChipsWithMore.vue";

import Roles from "@/entities/Roles";
import RouteNames from "@/entities/RouteNames";
import { User } from "@/generated/graphql";

@Component({
  components: {
    DashboardCardScaffold,
    InvitationModalWithButton,
    CardItemScaffold,
    HeartIcon,
    ItemChipsWithMore,
  },
  apollo: {
    favorites: {
      query: GET_FAVORITES,
      variables() {
        const managerId = this.currentUser.manager?.id;
        const managerConditions = !managerId ? {} : {
          managers: {
            _and: [
              {
                manager: {
                  id: {
                    _eq: managerId,
                  },
                },
              },
              {
                approved: {
                  _eq: true,
                },
              },
            ],
          },
        };

        return {
          favoritesFilter: {
            _and: [
              {
                approved: {
                  _eq: true,
                },
                deleted: {
                  _eq: false,
                },
              },
              {
                user: {
                  favorited_by_users: {
                    favorited_by_id: {
                      _eq: this.currentUserId,
                    },
                  },
                },
              },
              managerConditions,
            ],
          },
        }
      },
      update(data) {
        return data;
      }
    }
  }
})
export default class DashboardFavorites extends Vue {
  @Prop({type: String, required: true}) readonly companyId!: string;
  @Prop({type: String, required: true}) readonly currentUserId!: string;
  @Prop({type: String, required: true}) readonly currentUserRole!: string;
  @Prop({type: String, required: true}) readonly companyBusinessName!: string;
  @Prop({type: Object, required: true}) readonly currentUser!: User;

  routes = RouteNames;
  favorites:any = null;

  get contractors() {
    if (this.favorites) {
      return this.favorites.contractors;
    }
  }

  get isManager(): boolean {
    return this.currentUserRole === Roles.MANAGER;
  }

  get total() {
    if (this.favorites) {
      return this.favorites.total.aggregate.count;
    }
  }

  get contractorsInfo(): any[]|string {
    if (!this.contractors || !this.contractors.length) {
      return [];
    }
    return this.contractors.map((c: any) => {
      return {
        id: c.id,
        name: `${c.user.given_name} ${c.user.family_name}`,
        avatar: c.user.avatar,
      };
    });
  }
}
